<template>
  <div
    v-if="applicationReady && componentReady"
    class="questionnaire container"
  >
    <div class="questionnaire-top">
      <div v-if="!showWorksheet && !formSubmitted">
        <div
          v-for="(question, title) in currentQuestions"
          :key="question.id"
        >
          <div>
            <h1 class="text-center pb-4">
              {{ title }}
            </h1>
          </div>
          <b-row class="question-errors">
            <b-col
              cols="12"
              v-if="formAnswersData.questions[title] && formAnswersData.questions[title].invalid"
            >
              <div
                class="invalid-feedback"
              >
                <h3>{{ formAnswersData.questions[title].validationMessage }}</h3>
              </div>
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
            <div
              v-for="field in question.fields"
              :key="field.id"
              :class="question.display"
            >
              <generic-question
                :form-answers="formAnswers"
                :field="field"
                :question="question"
                :validate="$v.formAnswers[field.section]"
                :form-answers-data="formAnswersData"
              />
            </div>
          </b-row>
        </div>
      </div>
      <div v-else-if="showWorksheet && !formSubmitted">
        <div class="text-center">
          <h1>Reasonable Cause Worksheet</h1>
        </div>
        <div
          v-for="(question, title) in modalQuestions"
          :key="question.id"
        >
          <div class="pb-4">
            <h3>
              {{ title }}
            </h3>
          </div>
          <b-row class="justify-content-center">
            <div
              v-for="field in question.fields"
              :key="field.id"
              :class="question.display"
            >
              <generic-question
                :form-answers="formAnswers"
                :field="field"
                :question="question"
                :validate="$v.formAnswers[field.section]"
                :form-answers-data="formAnswersData"
                :title="title"
              />
            </div>
          </b-row>
        </div>
      </div>
      <b-row>
        <b-col
          v-if="formSubmitted"
          cols="12"
          class="screening-complete"
        >
          <b-row>
            <b-col
              cols="12"
              class="screening-complete-title"
            >
              <span
                class="success-message exit"
              >
                <h1>
                  Test Complete!
                </h1>
              </span>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <div class="questionnaire-bottom">
      <b-row>
        <b-col cols="12">
          <b-form>
            <b-form-row class="justify-content-center no-gutters">
              <b-col
                v-if="!formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-2"
              >
                <b-button
                  @click="newPreviousPage"
                  :disabled="canGoBack"
                  class="btn-green btn-nav"
                >
                  <b-icon-caret-left-fill />
                </b-button>
              </b-col>

              <b-col
                v-if="!canSubmitForm && !this.failedScreening"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-3"
              >
                <b-button
                  @click="checkQuestion"
                  class="btn-green btn-nav"
                >
                  <b-icon-caret-right-fill />
                </b-button>
              </b-col>

              <b-col
                v-if="canSubmitForm && !formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-3"
              >
                <b-button
                  @click="checkQuestion"
                  class="btn-green btn-nav"
                >
                  Submit
                </b-button>
              </b-col>

              <b-col
                v-if="formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation"
              >
                <b-button
                  @click="goHome"
                  class="btn-green btn-nav"
                >
                  <img
                    src="../assets/home-icon.png"
                    class="screening-icon"
                  >
                </b-button>
              </b-col>

              <b-col
                v-if="!formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-1"
              >
                <b-button
                  @click="goHome"
                  class="btn-green btn-nav order-md-1"
                >
                  <img
                    src="../assets/home-icon.png"
                  >
                </b-button>
              </b-col>

              <b-col
                v-if="formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation"
              >
                <b-button
                  @click="logout"
                  class="btn-green btn-nav"
                >
                  <img
                    src="../assets/log-out-icon-white.png"
                    class="icon-with-text"
                  >
                  Log out
                </b-button>
              </b-col>
            </b-form-row>
          </b-form>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
// import { mustBeTrue } from '../plugins/validators'
import { mapGetters } from 'vuex'
import mixin from '../mixins/forms.js'
import GenericQuestion from '@/views/GenericQuestion'

export default {
  components: { GenericQuestion },
  middleware: 'auth',
  name: 'EntryScreening',
  mixins: [mixin],
  // components: {
  //   'smooth-reflow': () => import(/* webpackPrefetch: true */ /* webpackChunkName: "smooth-reflow" */ '../components/SmoothReflow')
  // },
  data () {
    return {
      showReasonableCauseWorksheet: false,
      selectTestName: '',
      formAnswersData: {
        enterDateOfTest: {
          validationMessage: 'Date of entry is required'
        },
        enterTimeOfTest: {
          validationMessage: 'Time of entry is required'
        },
        selectTest: {
          validationMessage: 'Select test to continue'
        },
        selectDrugAlcoholTestReason: {
          validationMessage: 'Select a reason to continue'
        },
        selectDrugTestResult: {
          validationMessage: 'Select a result to continue',
          selectDefault: 'Drug Result'
        },
        selectAlcoholTestResult: {
          validationMessage: 'Select a result to continue',
          selectDefault: 'Alcohol Result'
        },
        selectCovidTestReason: {
          validationMessage: 'Select a reason to continue',
          getTitle: 'custom title'
        },
        selectCovidTestResult: {
          validationMessage: 'Select a result to continue'
        },
        enterDateOfObservation: {
          validationMessage: 'Date of observation is required'
        },
        enterTimeOfObservation: {
          validationMessage: 'Time of observation is required'
        },
        locationOfObservation: {
          validationMessage: 'Location of observation is required'
        },
        reasonableCauseEmployeeExplanation: {
          validationMessage: 'Explanation to employee is required'
        },
        questions: {
          'Select Drug/Alcohol test result': {
            validationMessage: 'Please select an option to continue',
            invalid: false
          }
        }
      },
      formAnswers: {
        enterDateOfTest: '',
        enterTimeOfTest: '',
        selectTest: null,
        selectDrugAlcoholTestReason: null,
        selectDrugTestResult: null,
        selectAlcoholTestResult: null,
        selectCovidTestAnswers: null,
        selectCovidTestResult: null,
        enterDateOfObservation: '',
        enterTimeOfObservation: '',
        locationOfObservation: '',
        reasonableCauseAppearance: '',
        reasonableCauseBehavior: '',
        reasonableCauseEyeMovement: '',
        reasonableCauseOdors: '',
        reasonableCauseSpeech: '',
        reasonableCauseObservedBehaviors: '',
        reasonableCauseEvidence: '',
        reasonableCauseEmployeeExplanation: ''
      }
    }
  },
  validations () {
    return {
      formAnswers: {
        enterDateOfTest: {
          required
        },
        enterTimeOfTest: {
          required
        },
        selectTest: {
          required
        },
        selectDrugAlcoholTestReason: {
          required
        },
        // selectDrugTestResult: {
        //   required
        // },
        // selectAlcoholTestResult: {
        //   required
        // },
        selectCovidTestReason: {
          required
        },
        selectCovidTestResult: {
          required
        },
        enterDateOfObservation: {
          required
        },
        enterTimeOfObservation: {
          required
        },
        locationOfObservation: {
          required
        },
        reasonableCauseEmployeeExplanation: {
          required
        }
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapGetters({
      user: 'authentication/user',
      hotspots: 'forms/hotspots',
      hasHotspots: 'forms/hasHotspots'
    }),
    alcoholResultValid () {
      return this.$v.formAnswers.selectAlcoholTestResult.$invalid
    },
    showWorksheet () {
      return this.showReasonableCauseWorksheet && this.currentPage === 2
    },
    componentReady () {
      if (this.loggedIn) {
        return this.currentQuestionnaire !== undefined &&
          this.questions !== undefined &&
          this.questionAnswersAndStatesSetup &&
          (this.currentQuestion !== undefined || this.formSubmitted)
      }
      return false
    },
    checkboxDisabledLength () {
      return this.checkboxDisabledState.length
    },
    testName () {
      if (this.formAnswers.selectTest) {
        return this.findQuestionBySection('selectTest').values.find(x => x.answer_value === this.formAnswers.selectTest).answer_text
      } else {
        return null
      }
    },
    modalQuestions () {
      const questions = this.questions.filter(x => x.relatesTo
        .includes('Cause'))
        .reduce((questions, question) => {
        // eslint-disable-next-line no-prototype-builtins
          if (!questions.hasOwnProperty(question.question)) {
            questions[question.question] = {
              fields: []
            }
          }
          questions[question.question].display = 'col-md-12'
          question.options = this.makeOptionsArray(question)
          question.options.unshift({
            text: 'Please select an option',
            value: null
          })
          questions[question.question].fields.push(question)
          questions[question.question].type = question.type
          return questions
        }, {})
      for (const title in questions) {
        // questions[title].options = this.makeOptionsArray(questions[title])
        if (questions[title].fields.length > 1) {
          questions[title].display = 'col-md-5'
          // console.log('COUNT ' + questions[title].fields.length)
        }
      }
      return questions
    },
    currentQuestions () {
      const questions = this.questions.filter(x => x.page === this.currentPage &&
        (x.relatesTo === '' || x.relatesTo.includes(this.testName)) &&
        !x.relatesTo.includes('Cause'))
        .reduce((questions, question) => {
        // eslint-disable-next-line no-prototype-builtins
          if (!questions.hasOwnProperty(question.question)) {
            questions[question.question] = {
              fields: []
            }
          }
          questions[question.question].display = 'col-md-6'
          question.options = this.makeOptionsArray(question)
          question.options.unshift({
            text: this.formAnswersData[question.section].selectDefault ?? 'Please select an option',
            value: null
          })
          questions[question.question].fields.push(question)
          questions[question.question].type = question.type
          return questions
        }, {})
      for (const title in questions) {
        // questions[title].options = this.makeOptionsArray(questions[title])
        if (questions[title].fields.length > 1) {
          questions[title].display = 'col-md-3'
          // console.log('COUNT ' + questions[title].fields.length)
        }
        if (title === 'Select Drug/Alcohol test result') {
          questions[title].invalid = false
          questions[title].validationMessage = 'You must select an option to continue'
        }
      }
      // console.log(questions);
      return questions
    }
  },
  watch: {
    formAnswers: {
      deep: true,
      handler () {
        if (this.currentPage === 3) {
          this.formAnswersData.questions['Select Drug/Alcohol test result'].invalid = !(this.formAnswers.selectDrugTestResult !== null ||
            this.formAnswers.selectAlcoholTestResult !== null)
        }
      }
    }
  },
  methods: {
    async init () {
      await this.setCurrentDateAndTime('testing')
      await this.setCurrentPage(1)
      await this.isMultiStep()
    },
    getAnswerByIndex (index) {
      const testName = this.testName
      switch (testName) {
        case 'COVID-PCR': // Covid
        case 'COVID-Binax Rapid Antigen Test':
          return this.currentQuestions['Select Covid test result'].fields[0].text
        case 'Drug/Alcohol':
          return this.currentQuestions['Select Covid test result'].fields[0].text
        default:
          return 0
      }
    },
    getQuestionValid (title) {
      console.log('invalid')
      return this.currentQuestions[title].invalid
    },
    checkQuestion () {
      if (this.currentPage === 1) {
        this.$v.formAnswers.enterTimeOfTest.$touch()
        this.$v.formAnswers.enterDateOfTest.$touch()
        this.$v.formAnswers.selectTest.$touch()
        if (
          !this.$v.formAnswers.enterTimeOfTest.$invalid &&
          !this.$v.formAnswers.enterDateOfTest.$invalid &&
          !this.$v.formAnswers.selectTest.$invalid
        ) {
          this.nextPage()
        }
      } else if (this.currentPage === 2) {
        if (this.testName === 'Drug/Alcohol') {
          this.$v.formAnswers.selectDrugAlcoholTestReason.$touch()
          if (!this.$v.formAnswers.selectDrugAlcoholTestReason.$invalid) {
            if (this.formAnswers.selectDrugAlcoholTestReason === '3' && !this.showReasonableCauseWorksheet) {
              this.showReasonableCauseWorksheet = true
            } else if (this.showReasonableCauseWorksheet) {
              this.$v.formAnswers.enterDateOfObservation.$touch()
              this.$v.formAnswers.enterTimeOfObservation.$touch()
              this.$v.formAnswers.locationOfObservation.$touch()
              this.$v.formAnswers.reasonableCauseEmployeeExplanation.$touch()
              if (
                !this.$v.formAnswers.enterDateOfObservation.$invalid &&
                !this.$v.formAnswers.enterTimeOfObservation.$invalid &&
                !this.$v.formAnswers.locationOfObservation.$invalid &&
                !this.$v.formAnswers.reasonableCauseEmployeeExplanation.$invalid
              ) {
                this.nextPage()
              }
            } else {
              this.nextPage()
            }
          }
        }
        if (this.testName === 'COVID-PCR' || this.testName === 'COVID-Binax Rapid Antigen Test') {
          this.$v.formAnswers.selectCovidTestReason.$touch()
          if (!this.$v.formAnswers.selectCovidTestReason.$invalid) {
            this.nextPage()
          }
        }
      } else if (this.currentPage === 3) {
        if (this.testName === 'Drug/Alcohol') {
          if (this.formAnswers.selectDrugTestResult !== null ||
          this.formAnswers.selectAlcoholTestResult !== null) {
            if ((this.formAnswers.selectAlcoholTestResult !== '1' && this.formAnswers.selectAlcoholTestResult !== null) ||
              (this.formAnswers.selectDrugTestResult !== '1' && this.formAnswers.selectDrugTestResult !== null)) {
              this.setFailedScreening(true)
            }
            this.submitForm()
          } else {
            this.formAnswersData['Select Drug/Alcohol test result'].invalid = true
          }
        }
        if (this.testName === 'COVID-PCR' || this.testName === 'COVID-Binax Rapid Antigen Test') {
          this.$v.formAnswers.selectCovidTestResult.$touch()
          if (!this.$v.formAnswers.selectCovidTestResult.$invalid) {
            if (this.formAnswers.selectCovidTestResult !== '2') {
              this.setFailedScreening(true)
            }
            this.submitForm()
          }
        }
      }
    },
    newPreviousPage ({ commit, state }) {
      if (this.currentPage > 1) {
        if (this.currentPage === 2 && this.showReasonableCauseWorksheet) {
          this.showReasonableCauseWorksheet = false
        } else {
          this.$store.commit('forms/commitPreviousPage')
        }
      }
    },
    submitForm () {
      this.setFormSubmitted(!this.formSubmitted)
      this.addFormResults(this.answersById)
    },
    // submitFormFailure () {
    //   this.setFailedScreening(true)
    //   this.showFailedScreeningModal = !this.showFailedScreeningModal
    //   this.submitForm()
    // },
    makeOptionsArray (field) {
      const values = field.values
      const options = values.reduce((options, value) => {
        options.push({
          value: value.answer_value,
          text: value.answer_text
        })
        return options
      }, [])
      console.log(options)
      return options
    }
    // options.push({
    //   value: null,
    //   text: this.formAnswersData[value.section].selectDefault ?? 'Please select an option'
    // })
    //   const option = {
    //     value: value.answer_value,
    //     text: value.answer_text

  }

}
</script>

<style scoped lang="scss">
.questionnaire-bottom {
  text-align: center;
}
</style>
